import { render, staticRenderFns } from "./DeleteKyc.vue?vue&type=template&id=1ded74c4&"
import script from "./DeleteKyc.vue?vue&type=script&lang=js&"
export * from "./DeleteKyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports